import { ActionTypes } from './actionTypes';
import type { HideGeofences, HideGeofencesForceVisibility, ShowGeofences, ShowGeofencesForceVisibility, ToggleShowGeofences, ToggleShowGeofencesForceVisibility } from './actions';

export const showGeofences = (): ShowGeofences => ({
  type: ActionTypes.SHOW_GEOFENCES,
});

export const hideGeofences = (): HideGeofences => ({
  type: ActionTypes.HIDE_GEOFENCES,
});

export const toggleShowGeofences = (): ToggleShowGeofences => ({
  type: ActionTypes.TOGGLE_SHOW_GEOFENCES,
});

export const toggleShowGeofencesForceVisibility = (): ToggleShowGeofencesForceVisibility => ({
  type: ActionTypes.TOGGLE_SHOW_GEOFENCES_FORCE_VISIBILITY,
});

export const showGeofencesForceVisibility = (): ShowGeofencesForceVisibility => ({
  type: ActionTypes.SHOW_GEOFENCES_FORCE_VISIBILITY,
});

export const hideGeofencesForceVisibility = (): HideGeofencesForceVisibility => ({
  type: ActionTypes.HIDE_GEOFENCES_FORCE_VISIBILITY,
});
